import { apiService, Endpoints } from "api";

export const resetPasswordRequest = async ({ email }: { email: string }) => {
  const { data } = await apiService.post(
    Endpoints.Users.Post.ResetPassword(email)
  );

  return data;
};
